import PropTypes from "prop-types";
// material
import { Grid } from "@mui/material";
import { BlogPostCard } from "../blog";

// ----------------------------------------------------------------------

ProductList.propTypes = {
    products: PropTypes.array.isRequired,
    draggable: PropTypes.bool,
    activeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    activeDrag: PropTypes.bool,
    suppressNavigationClick: PropTypes.bool,
    onConsumeNavigationSuppression: PropTypes.func,
    onContextMenu: PropTypes.func,
};

export default function ProductList({
    products,
    selected,
    onSelect,
    draggable,
    activeId,
    activeDrag,
    suppressNavigationClick,
    onConsumeNavigationSuppression,
    onContextMenu,
    ...other
}) {
    return (
        <Grid container spacing={3} {...other}>
            {products.map((product, index) => (
                // <Grid key={product.content.slug} item xs={12} sm={6} md={3}>

                // </Grid>
                <BlogPostCard
                    key={product.nav_id ?? product.content.slug}
                    post={product}
                    sortableId={product.nav_id}
                    index={index}
                    route="/dashboard/product/"
                    selected={selected.includes(product.content.slug)}
                    onSelect={onSelect}
                    draggable={draggable}
                    activeId={activeId}
                    activeDrag={activeDrag}
                    suppressNavigationClick={suppressNavigationClick}
                    onConsumeNavigationSuppression={
                        onConsumeNavigationSuppression
                    }
                    onContextMenu={onContextMenu}
                />
            ))}
        </Grid>
    );
}
